var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCustomHomeSale = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1B7690",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.712 9.507h-.863v-1.37h2.836c.726 0 1.315-.614 1.315-1.37 0-.756-.589-1.37-1.315-1.37H8.086V4.37c0-.757-.588-1.37-1.315-1.37-.725 0-1.315.613-1.315 1.37v1.027h-1.14C3.588 5.397 3 6.011 3 6.767c0 .756.589 1.37 1.315 1.37h1.141V26.63c0 .757.59 1.37 1.316 1.37.726 0 1.314-.613 1.314-1.37V8.137h5.558v1.37h-.864c-1.813 0-3.287 1.536-3.287 3.425v5.136c0 1.887 1.475 3.425 3.287 3.425h10.932c1.813 0 3.288-1.537 3.288-3.425v-5.136c0-1.888-1.475-3.425-3.288-3.425zm-7.438-1.37h3.945v1.37h-3.945v-1.37zm-3.58 9.566c-.468 0-.93-.128-1.162-.262l.189-.798c.25.133.632.265 1.029.265.426 0 .65-.184.65-.462 0-.266-.194-.418-.687-.602-.681-.248-1.126-.64-1.126-1.262 0-.729.585-1.286 1.552-1.286.463 0 .804.102 1.047.215l-.208.781a1.85 1.85 0 0 0-.858-.204c-.401 0-.596.19-.596.412 0 .272.232.392.76.602.725.278 1.065.671 1.065 1.274 0 .718-.529 1.327-1.655 1.327zm4.73-.064-.317-1.096h-1.174l-.292 1.096h-.961l1.252-4.271h1.217l1.272 4.271h-.997zm1.549 0v-4.271h.93v3.46h1.63v.811h-2.56zm5.725 0h-2.614v-4.271h2.53v.792h-1.6v.887h1.508v.786h-1.508v1.014h1.684v.792z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.51 14.09h-.012c-.06.253-.121.576-.188.824l-.243.906h.907l-.256-.906c-.073-.254-.147-.57-.207-.824z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCustomHomeSale);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-custom-home-sale.69c27d968e3e114e6dc0e2e1b2eb2704.svg";